module.exports = __webpack_public_path__ + "img/directions_bus_black_24dp.df78b664.svg";